import { createSlice } from "@reduxjs/toolkit";
import { login, googleLogin, signup, resetPassword, sendotp, verifyotp, verifyloginOtp, logout, verifyAccount } from "./authAction";

const initialState = {
  verifyingOtp: false,
  loading: false,
  error: null,
  isTwoFA: false,
  twoFAMethod: null,
  shouldVerifyAccount: false,
  loginStatus: "idle",
  sendotpStatus: 'idle',
  isVerifiedOTP: false,
  loggingOut: false
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetLoginStatus: (state) => {
      state.loginStatus = initialState.loginStatus;
      state.isTwoFA = initialState.isTwoFA
      state.twoFAMethod = initialState.twoFAMethod
    },
    resetSendOtpStatus: (state) => {
      state.sendotpStatus = initialState.sendotpStatus
    },
    resetIsVerifiedOtp: (state) => {
      state.isVerifiedOTP = initialState.isVerifiedOTP
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(signup.pending, (state) => {
        state.loading = true;
      })
      .addCase(signup.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(signup.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(login.pending, (state) => {
        state.loading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status === "success") {
          if (action.payload.twoFA) {
            state.isTwoFA = true
            state.twoFAMethod = action.payload.twoFAMethod
          } else if (action.payload.accountVerified === false) {
            state.shouldVerifyAccount = true
          } else {
            state.loginStatus = "success";
          }
        } else {
          state.loginStatus = "failed";
        }
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
      });


    builder
      .addCase(verifyAccount.pending, (state) => {
        state.verifyingOtp = true;
      })
      .addCase(verifyAccount.fulfilled, (state, action) => {
        state.verifyingOtp = false;
        if (action.payload.status === "success") {
          state.loginStatus = "success";
        } else {
          state.loginStatus = "failed";
        }
      })
      .addCase(verifyAccount.rejected, (state, action) => {
        state.verifyingOtp = false;
      });


    builder
      .addCase(googleLogin.pending, (state) => {
        state.loading = true;
      })
      .addCase(googleLogin.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status === "success") {
          if (action.payload.twoFA) {
            state.isTwoFA = true
            state.twoFAMethod = action.payload.twoFAMethod
          } else if (action.payload.accountVerified === false) {
            state.shouldVerifyAccount = true
          } else {
            state.loginStatus = "success";
          }
        } else {
          state.loginStatus = "failed";
        }
      })
      .addCase(googleLogin.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      // otp login state
      .addCase(verifyloginOtp.pending, (state) => {
        state.verifyingOtp = true;
        state.error = null;
      })
      .addCase(verifyloginOtp.fulfilled, (state, action) => {
        state.verifyingOtp = false;
        if (action.payload.status === 'success') {
          state.loginStatus = 'success';
        } else {
          state.loginStatus = 'failed'
        }
      })
      .addCase(verifyloginOtp.rejected, (state, action) => {
        state.verifyingOtp = false;
        state.error = action.error.message;
      })

    builder
      // sendt OTP state
      .addCase(sendotp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendotp.fulfilled, (state, action) => {
        state.loading = false;
        state.sendotpStatus = 'success'
      })
      .addCase(sendotp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

    builder
      // verifyOTP state
      .addCase(verifyotp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyotp.fulfilled, (state, action) => {
        state.loading = false;
        state.isVerifiedOTP = true
      })
      .addCase(verifyotp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

    builder
      //reset password state
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(logout.pending, (state) => {
        state.loggingOut = true
      })
      .addCase(logout.fulfilled, (state) => {
        state.loggingOut = false
      })
      .addCase(logout.rejected, (state) => {
        state.loggingOut = false
      })
  },
});

export const { resetLoginStatus, resetIsVerifiedOtp, resetSendOtpStatus } = authSlice.actions;
export default authSlice.reducer;
